import React from 'react';
import { Path, FieldValues } from 'react-hook-form';
import { CriteriaBodyCell } from './CriteriaBodyCell';
import { InputField } from 'components/form';
import { CriteriaBodyCellProps } from 'modules/jsonRulesCriterias/scorecardCriteria/types';

export const CriteriaWithScoreBodyCell = <FormValues extends FieldValues = FieldValues>({
  ruleType,
  control,
  name,
}: CriteriaBodyCellProps<FormValues>) => {
  return (
    <>
      <CriteriaBodyCell control={control} ruleType={ruleType} name={name} />

      <InputField
        label="Score"
        control={control}
        name={`${name}.score` as Path<FormValues>}
        inputProps={{ type: 'number', variant: 'outlined', style: { flexBasis: '33%' } }}
      />
    </>
  );
};
